export default function generer() {
  return {
    nombreJourDecalage: null,
    finDeMois: false,
    jourFinDeMois: null,
  };
}
